import { Actions } from './image-types.actions'
import { fromJS } from 'immutable'
import * as ImageTypesTypes from './image-types.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createImageType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateImageType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function imageTypesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ImageTypesTypes.UPDATE_IMAGE_TYPE_REQUEST: {
      return state.setIn(['updateImageType', 'isLoading'], true)
    }

    case ImageTypesTypes.UPDATE_IMAGE_TYPE_SUCCESS: {
      return state.setIn(['updateImageType', 'isLoading'], false)
    }

    case ImageTypesTypes.UPDATE_IMAGE_TYPE_FAILURE: {
      return state.setIn(['updateImageType', 'isLoading'], false)
    }

    case ImageTypesTypes.CREATE_IMAGE_TYPE_REQUEST: {
      return state.setIn(['createImageType', 'isLoading'], true)
    }

    case ImageTypesTypes.CREATE_IMAGE_TYPE_SUCCESS: {
      return state.setIn(['createImageType', 'isLoading'], false)
    }

    case ImageTypesTypes.CREATE_IMAGE_TYPE_FAILURE: {
      return state.setIn(['createImageType', 'isLoading'], false)
    }

    case ImageTypesTypes.DELETE_IMAGE_TYPE_REQUEST: {
      return state
    }

    case ImageTypesTypes.DELETE_IMAGE_TYPE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case ImageTypesTypes.DELETE_IMAGE_TYPE_FAILURE: {
      return state
    }

    case ImageTypesTypes.FETCH_IMAGE_TYPES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case ImageTypesTypes.FETCH_IMAGE_TYPES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case ImageTypesTypes.FETCH_IMAGE_TYPES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case ImageTypesTypes.FETCH_IMAGE_TYPE_REQUEST: {
      return state.setIn(['updateImageType', 'isLoading'], true)
    }

    case ImageTypesTypes.FETCH_IMAGE_TYPE_SUCCESS: {
      return state
        .setIn(['updateImageType', 'isLoading'], false)
        .setIn(
          ['updateImageType', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case ImageTypesTypes.FETCH_IMAGE_TYPE_FAILURE: {
      return state.setIn(['updateImageType', 'isLoading'], false)
    }

    case ImageTypesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case ImageTypesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
